import type { ReactNode } from 'react'
import { CampaignTotpStepUpProvider } from '@/contexts/CampaignTotpStepUpContext'
import { AdminOnlyRoute } from '@/components/ProtectedRoute/AdminOnlyRoute'
import { useAuth } from '@/hooks/useAuth'
import {
  ADMIN_SENSITIVE_TOTP_STEP_UP_COPY,
  canAccessAdminSensitiveArea,
} from '@/lib/campaign-totp-step-up'
import { CampaignTotpStepUpGate } from './CampaignTotpStepUpGate'

type AdminSensitiveTotpRouteProps = {
  children: ReactNode
  forceRefresh?: boolean
}

export function AdminSensitiveTotpRoute({
  children,
  forceRefresh = false,
}: AdminSensitiveTotpRouteProps) {
  const { guard } = useAuth()

  return (
    <AdminOnlyRoute>
      <CampaignTotpStepUpProvider copy={ADMIN_SENSITIVE_TOTP_STEP_UP_COPY}>
        <CampaignTotpStepUpGate
          canAccess={canAccessAdminSensitiveArea(guard)}
          fallbackTo="/home-drftadmin"
          forceRefresh={forceRefresh}
        >
          {children}
        </CampaignTotpStepUpGate>
      </CampaignTotpStepUpProvider>
    </AdminOnlyRoute>
  )
}
